import _define_property from "@swc/helpers/src/_define_property.mjs";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ContentSection } from "@cinch-labs/design-system";
import { getStoryblokImageServiceUrl } from "@cinch-nx/data-storyblok";
import { renderWithResolver } from "@cinch-nx/landing-ui-shared";
import cx from "classnames";
import styles from "./text-inline-image.module.css";
var _alt;
export var TextInlineImage = function(param) {
    var body = param.body, image = param.image, _imagePosition = param.imagePosition, imagePosition = _imagePosition === void 0 ? "right" : _imagePosition;
    return /*#__PURE__*/ _jsxs("div", {
        className: cx(styles.wrapper, _define_property({}, styles.imageLeft, imagePosition === "left")),
        "data-testid": "text-inline-image-container",
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: styles.imageWrapper,
                children: /*#__PURE__*/ _jsx("img", {
                    src: getStoryblokImageServiceUrl(image.filename, {
                        width: 900,
                        filters: [
                            {
                                quality: 60
                            }
                        ]
                    }),
                    className: styles.image,
                    alt: (_alt = image.alt) !== null && _alt !== void 0 ? _alt : undefined
                })
            }),
            /*#__PURE__*/ _jsx(ContentSection, {
                classNames: {
                    body: "storyblokRichTextBody"
                },
                children: renderWithResolver(body)
            })
        ]
    });
};
